import { spAffiliationFormLocs } from './components/affiliation-form/affiliation-form.locs';
import { spAchievementSearchListLocs } from './components/affiliation-search/affiliation-search.locs';
import { spSettingsAffiliationTemplateLocs } from './components/affiliation-template-ss/affiliation-template-ss.locs';

export const affiliationSettingsModuleLocs = {
	...spAchievementSearchListLocs,
	...spSettingsAffiliationTemplateLocs,
	...spAffiliationFormLocs,
};
